import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  amPrivacyPolicy: null
};
export const globalPrivacyPolicyInfoSlice = createSlice({
  name: "globalPrivacyPolicyInfo",
  initialState,
  reducers: {
    updateGlobalPrivacyPolicy: (state, action) => {
      state.amPrivacyPolicy = action.payload;
    }
  }
});

export const { updateGlobalPrivacyPolicy } =
  globalPrivacyPolicyInfoSlice.actions;
export default globalPrivacyPolicyInfoSlice.reducer;
